import { render, staticRenderFns } from "./dots_general_tab.vue?vue&type=template&id=7cb22a9a&scoped=true&"
import script from "./dots_general_tab.vue?vue&type=script&lang=js&"
export * from "./dots_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb22a9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb22a9a')) {
      api.createRecord('7cb22a9a', component.options)
    } else {
      api.reload('7cb22a9a', component.options)
    }
    module.hot.accept("./dots_general_tab.vue?vue&type=template&id=7cb22a9a&scoped=true&", function () {
      api.rerender('7cb22a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/dots/location/tabs/dots_general_tab.vue"
export default component.exports